import { useLocation, useNavigate } from "react-router-dom";
import "./TypeCarRentalPage.css";
const TypeCarRentalPage= () => {
  const location = useLocation();
  const navigate = useNavigate();

  let data = location.state;

  // ✅ fallback (important)
  if (!data) {
    const saved = sessionStorage.getItem("selectedCar");
    data = saved ? JSON.parse(saved) : null;
  }

  if (!data) return <h2>No Data Found</h2>;

  const handleClick = (type) => {
    const updatedData = {
      ...data,
      rentalType: type,
      totalPrice:
        type === "driver" ? data.totalPrice + 300 : data.totalPrice,
    };

    // ✅ store again
    sessionStorage.setItem("selectedCar", JSON.stringify(updatedData));

    if (type === "self") {
      navigate("/type-self-drive-detail-page", { state: updatedData });
    } else {
      navigate("/type-with-driver-detail-page", { state: updatedData });
    }
  };

return (
  <div className="type-container">
    <div className="type-card">
      <h2>Select Rental Type</h2>

      <div className="type-buttons">
        <button
          className="type-btn self-btn"
          onClick={() => handleClick("self")}
        >
          🚗 Self Drive
        </button>

        <button
          className="type-btn driver-btn"
          onClick={() => handleClick("driver")}
        >
          🧑‍✈️ With Driver
        </button>
      </div>
    </div>
  </div>
);
};

export default TypeCarRentalPage;